import React from 'react'

import { Button, Input, ModalBox } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import { validationSchema } from './consts'
import type { FormValues, Props } from './types'
import { convertStringToAlphanumericWithDash } from './utils'

const getCursorPositionOffset = (prevValue: string, newValue: string): number => {
  const diff = newValue.length - prevValue.length

  if (diff === 1 || diff === 2) return 1

  return 0
}

export const SlugChangeModal = ({ title, slug, shopBaseUri, prepend, onSubmit, close }: Props) => {
  const formik = useFormik<FormValues>({
    initialValues: {
      slug,
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values.slug)
      close()
    },
  })

  const setSlugifiedFieldValue = (field: string, e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = convertStringToAlphanumericWithDash(e.target.value)

    formik.setFieldValue(field, newValue)

    const cursorPositionOffset = getCursorPositionOffset(e.target.value, newValue)
    const newCursorPosition = (e.target.selectionStart || 0) + cursorPositionOffset

    setTimeout(() => {
      e.target.selectionStart = newCursorPosition
      e.target.selectionEnd = newCursorPosition
    }, 0)
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <ModalBox
        title={title}
        buttons={[
          <Button label="Cancel" appearance="secondary" onClick={close} />,
          <Button
            label="Update"
            appearance="primary"
            type="submit"
            disabled={!formik.isValid || !formik.dirty}
          />,
        ]}
        onClose={close}
      >
        <Input
          prepend={<>{`${shopBaseUri}/${prepend}/`}&lrm;</>}
          required
          autoFocus
          {...formik.getFieldProps('slug')}
          onChange={(e) => {
            setSlugifiedFieldValue('slug', e)
          }}
        />
      </ModalBox>
    </form>
  )
}
